import { render, staticRenderFns } from "./ValidationWorkFlowActionPage.vue?vue&type=template&id=047aaf05&"
import script from "./ValidationWorkFlowActionPage.vue?vue&type=script&lang=js&"
export * from "./ValidationWorkFlowActionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports